import React, { lazy, Suspense, useEffect } from 'react';
//router
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';

// auth
import { ProtectedRoute } from './protected-route';
import { authAtom } from '../recoil/auth/atom';
import { removeToken } from '../services/auth-guard';
import { getUser } from '../services/admin-service';
import { useLocation } from 'react-router-dom';

const Default = lazy(() => import('../layouts/dashboard/default'));
const Simple = lazy(() => import('../layouts/dashboard/simple'));
const Error404 = lazy(() => import('../views/dashboard/errors/error404'));

const IndexRouters = () => {
  const [auth, setAuth] = useRecoilState(authAtom);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let unmounted = false;
    const fetchData = async () => {
      try {
        setAuth({ ...auth, isLoading: true });
        const user = await getUser();
        if (unmounted) return;
        if (user) {
          setAuth({ ...auth, isLoading: false, user: user });
        } else {
          setAuth({ ...auth, isLoading: false, error: 'Something Went Wrong' });
          navigate('/auth/sign-in', { state: { from: location } });
        }
      } catch (err) {
        setAuth({ ...auth, isLoading: false });
        removeToken();
        navigate('/auth/sign-in', { state: { from: location } });
      }
    };
    fetchData();
    return () => (unmounted = true);
  }, []);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ProtectedRoute>
                <Default />
              </ProtectedRoute>
            </Suspense>
          }
        />

        <Route
          path="/dashboard/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ProtectedRoute>
                <Default />
              </ProtectedRoute>
            </Suspense>
          }
        />

        <Route
          path="auth/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <ProtectedRoute>
                <Simple />
              </ProtectedRoute>
            </Suspense>
          }
        />

        <Route
          path="/*"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Error404 />
            </Suspense>
          }
        ></Route>
      </Routes>
    </>
  );
};

export default IndexRouters;
